import buildHotelData from '@/js/common/Domain/Factory/service/buildHotelData';
import HotelEntity from '../Entity/Hotel';

export default (data) => {
    const hotel = buildHotelData(data);

    const element = data.attributes;
    if (typeof element !== 'undefined') {
        hotel.animation = _.contains(element, 157) || _.contains(element, 229);
        hotel.familyRooms = _.contains(element, 170);
        hotel.diving = _.contains(element, 68) || _.contains(element, 129);
        hotel.freeSafe = _.contains(element, 66) || _.contains(element, 78);
        hotel.fitnessCenter = _.contains(element, 127);
        hotel.freeMiniBar = _.contains(element, 76);
        hotel.skiEquipment = _.contains(element, 107);
        hotel.honeyMoon = _.contains(element, 169) || _.contains(element, 220);
        hotel.waterSports = _.contains(element, 119);
        hotel.spaAndHealth = _.contains(element, 147);
        hotel.nightClub = _.contains(element, 158);
        hotel.personsWithDisabilities = _.contains(element, 168);
        hotel.noSmokingRooms = _.contains(element, 171);
        hotel.smokingRooms = _.contains(element, 201);
    }

    return new HotelEntity(hotel);
};